export const enum SenderRole {
  USER = 'user',
  ASSISTANT = 'assistant'
}

export const enum RequestStatus {
  PROCESSING = 'processing',
  COMPLETED = 'completed',
  ERROR = 'failed'
}

export const enum SubscriptionPlan {
  LITE = 'lite',
  PRO = 'pro',
  CUSTOM = 'custom'
}

export const enum MessageVote {
  LIKE = 'like',
  DISLIKE = 'dislike',
  NEUTRAL = 'neutral'
}

export const enum AssistantFeedback {
  THINKING = 'thinking',
  CONTENT = 'content',
  ERROR = 'error',
  COMPLETION = 'completion'
}

export const enum AssistantContentType {
  INTERIM_ANSWER = 'interim_answer',
  BLOCKS = 'blocks',
  CLARIFICATION = 'clarification',
  OUT_OF_SCOPE = 'out_of_scope',
  ERROR_RESPONSE = 'error_response',
  TOKEN_LIMIT_ERROR = 'token_limit_error'
}

export const enum AssistantErrorType {
  PROCESSING_ERROR = 'processing_error',
  TOKEN_LIMIT = 'token_limit',
  SQL_ERROR = 'sql_error'
}

export const enum AssistantCompletionType {
  SUCCESS = 'success',
  PARTIAL_SUCCESS = 'partial_success'
}

export const enum ActionType {
  FOLLOW_UP_QUESTIONS = 'follow_up_questions'
}
